import React, { useEffect, useState } from 'react';
import { DiGoogleDrive } from "react-icons/di";
import styles from "./PageEdit.module.css"

const DRIVE_API_KEY = process.env.REACT_APP_DRIVE_API_KEY;

export default function GoogleDrivePicker({ onPick }) {

  const [pickerReady, setPickerReady] = useState(false);

  const API_URL =
    process.env.NODE_ENV === 'development'
      ? 'http://localhost:3000'
      : 'https://api.hillerodfrimenighed.dk';

  useEffect(() => {
    // Load Google Picker script
    const script = document.createElement('script');
    script.src = 'https://apis.google.com/js/api.js';
    script.onload = () => {
      window.gapi.load('picker', () => setPickerReady(true));
    };
    document.body.appendChild(script);
  }, []);

  const openPicker = async () => {
    if (!pickerReady) return;
    try {
      // Hit the access token validation backend
      const v = await fetch(`${API_URL}/user/auth/validate`, { credentials: "include" });
      if (!v.ok) {
        alert("Din session er udløbet – log ind igen.");
        return;
      }

      const r = await fetch(`${API_URL}/user/google/access-token`, { credentials: "include" });
      if (!r.ok) {
        alert("Kunne ikke hente Google adgangstoken.");
        return;
      }
      const { token } = await r.json();

      const view = new window.google.picker.DocsView(window.google.picker.ViewId.DOCS_IMAGES)
        .setIncludeFolders(true)
        .setSelectFolderEnabled(true)
        .setParent('1zKJ1Z7DeEEU3V3xi3l6luFWgGLXJTcBa');

      const picker = new window.google.picker.PickerBuilder()
        .addView(view)
        .setOAuthToken(token)
        .setDeveloperKey(DRIVE_API_KEY)
        .setCallback(pickerCallback)
        .build();

      picker.setVisible(true);
    } catch (err) {
        console.error("Token validation failed", err);
        alert('Din session er udløbet – prøv at logge ind igen.');
    }
  };

  const pickerCallback = async (data) => {
    console.log('Full Picker Data:', data);
    if (data.action === window.google.picker.Action.PICKED) {
      const file = data.docs[0];
      const fileId = file.id;
      
      
      const serverUrl =
        process.env.NODE_ENV === "development"
          ? "http://localhost:3000"
          : "https://api.hillerodfrimenighed.dk";
      
      const imageUrl = `${serverUrl}/drive/proxyImage/${fileId}`;

      const response = await fetch(imageUrl, { method: 'HEAD' });

      if (!response.ok) {
        if (response.status === 500) {
          //ensure that the image is shared properly on the drive
          alert('Billedet kunne ikke hentes (404) – måske er det ikke delt korrekt eller er blevet slettet.');
        } 
        return;
      }

      // Success – pass the image back
      if (onPick) onPick({ fileId, imageUrl, name: file.name });

    }
  };

  return (
      <DiGoogleDrive className={styles.iconBnt} onClick={openPicker}/>
  );
}
